import React from "react";
import { labels } from "../../../../../../../localization/labels";
import { Modal, Form, Col, Row } from "react-bootstrap";
import Table from "../../../../../../core/Table";
import DropDown from "../../../../../../core/DropDown";
import SubmitButton from "../../../../../../core/SubmitButton";
import ProcessComponent from "../../../../../../core/ProcessComponent";
import { constants } from "../../../../../../../utils/Constants";
import { Affix } from "antd";

const InvolvementRoleTypes = ({
  node,
  data,
  columns,
  paginationOptions,
  onTableChange,
  selectRow,
  handleOnDelete,
  handleShow,
  show,
  handleClose,
  entity,
  onChange,
  onSave,
  disabled,
  involvementRoleTypes,
  pageInfo,
  sortInfo
}) => {
  return (
    <ProcessComponent processes={[constants.OPERATION_SECURITY_ADMINISTRATION]}>
      <div>
        <div className="table-buttons-container">
          <Table
            node={node}
            data={data}
            columns={columns}
            paginationOptions={paginationOptions}
            onTableChange={onTableChange}
            selectRow={selectRow}
            onDeleteRow={handleOnDelete}
            onCreateRow={handleShow}
            tableLabel={labels.involvementRoleTypes}
            pageInfo={pageInfo}
            sortInfo={sortInfo}
            showTableHeader
          />
        </div>
        <Modal show={show} onHide={handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>{labels.involvementRoleType}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col sm="3">
                  <Form.Label className="Label">
                    {labels.involvementRoleType}
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Group
                    controlId="involvementRoleType"
                    className="form-group required"
                  >
                    <DropDown
                      value={entity}
                      options={involvementRoleTypes.map(x => ({
                        value: x,
                        label: x.name
                      }))}
                      onChange={onChange}
                      placeholder={labels.involvementRoleTypePlaceholder}
                      required={true}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col sm="3">
                  <Form.Label className="Label">
                    {labels.description}
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Group>
                    <Col></Col>
                    <Col>
                      <Form.Label>{entity.description}</Form.Label>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Affix offsetBottom={true}>
              <SubmitButton type="close" onClick={handleClose} />
              <SubmitButton type="save" onClick={onSave} disabled={disabled} />
            </Affix>
          </Modal.Footer>
        </Modal>
      </div>
    </ProcessComponent>
  );
};

export default InvolvementRoleTypes;
